// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterLayer {
  width: 292px;
  height: 60vh;
  border-right: 1px solid #2A3A4F;
  border-top-right-radius: 12px;
  background-color: #121B26;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 1;
}
.filterLayer.expandView {
  position: fixed;
  height: 100vh;
}
.filterLayer .filterHeader {
  width: unset;
  height: 40px;
  background-color: #0E2343;
  border-top-right-radius: 12px;
  color: #FDFDFD;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-weight: 500;
  font-size: 14px;
  gap: 8px;
}
.filterLayer .filterHeader .filterBack,
.filterLayer .filterHeader .filterReset,
.filterLayer .filterHeader .filterParent {
  cursor: pointer;
  display: flex;
}
.filterLayer .filterHeader .filterReset {
  align-items: center;
  margin-right: 6px;
}
.filterLayer .filterHeader .filterText {
  flex-grow: 1;
}
.filterLayer .filterHeader .filterResetText {
  font-size: 12px;
  position: relative;
  top: 1px;
}
.filterLayer .filterBody {
  height: calc(100% - 56px);
  margin-right: 5px;
  margin-top: 16px;
  flex: 1;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  padding-top: 0px;
}
.filterLayer .filterBody .sectionHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filterLayer .filterBody .sectionHeader .sectionText {
  font-weight: 600;
  font-size: 14px;
}
.filterLayer .filterBody .sectionHeader .sectionIcon {
  display: flex;
  fill: #98A6B8;
  cursor: pointer;
}
.filterLayer .filterBody .padding-top-14 {
  padding-top: 14px;
}
.sectionBody .radioParent ev-radio-group {
  display: contents !important;
}
.sectionBody .radioParent ev-radio-group label {
  display: none;
}
.sectionBody .radioParent ev-radio-group ev-radio[checked] label {
  color: #FDFDFD;
}
.sectionBody .radioParent ev-radio-group ev-radio label {
  color: #8998AB;
  display: inline-block;
  margin-bottom: 0px;
  font-weight: var(--font-weight-medium);
}
.sectionBody .radioParent ev-radio-group ev-radio .form-control {
  display: flex;
  width: 1.0625rem;
  height: 1.0625rem;
  border: 3px solid transparent;
  border-radius: 50%;
  box-shadow: 0 0 0 0.0625rem #5D718C;
  margin: 0;
  outline: none;
  background-color: #0D1117;
}
.sectionBody .radioParent ev-radio-group ev-radio input[type="radio"]:checked {
  background-color: #8BB6F7;
  border-color: #0D1117;
}
.sectionBody .textfield ev-text-input {
  --color-input-default-border: #384D69;
  --color-input-default-border-hover: #384D69;
  --color-highlight: #386DFF;
}
.sectionBody .textfield ev-text-input label {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}
.sectionBody .textfield ev-text-input .form-control {
  background-color: unset;
  border: unset;
  cursor: unset;
  color: #FDFDFD;
}
.sectionBody .textfield ev-text-input .form-control:focus {
  border-color: unset;
  box-shadow: unset;
}
.sectionBody .multiselect ev-combobox {
  --color-neutral-background: #0D1117;
  --color-red-600: #1C2633;
  --color-neutral-border: #8998AB;
  --color-neutral-surface-1: #1C2633;
  --color-neutral-surface-2: #1C2633;
  --color-neutral-surface-3: #1C2633;
  --color-primary-surface-2: #1C2633;
  --color-neutral-surface-4: #384D69;
  --color-neutral-text-medium: #8998AB;
  width: 100%;
}
.floating-tooltip {
  position: fixed;
  transform: translateX(-50%);
  background: #2563eb;
  color: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  z-index: 1000;
  pointer-events: none;
}
.floating-tooltip .tooltip-arrow {
  position: absolute;
  top: 24px;
  border-width: 11px;
  border-style: solid;
  border-color: #2563eb transparent transparent transparent;
  opacity: 1;
  transform: translateX(-50%);
}
/* Text input suggestions styles */
.text-suggestions {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.suggestion-item {
  padding: 8px 12px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
}
.suggestion-item:hover {
  background-color: #f0f0f0;
}
.custom-text-input {
  position: relative;
}
/* Custom scrollbar styles - prevent flickering */
.scrollContent::-webkit-scrollbar,
.multiselect-selected::-webkit-scrollbar {
  width: 3px;
}
.scrollContent::-webkit-scrollbar-track,
.multiselect-selected::-webkit-scrollbar-track {
  background: transparent;
}
.scrollContent::-webkit-scrollbar-thumb,
.multiselect-selected::-webkit-scrollbar-thumb {
  background: #4B5F7A;
  border-radius: 4px;
}
.scrollContent::-webkit-scrollbar-thumb:hover,
.multiselect-selected::-webkit-scrollbar-thumb:hover {
  background: #3a4b60;
}
/* Custom Multi-Select Styles - Evolve-like - prevent flickering */
.custom-multiselect {
  margin-bottom: 10px;
  position: relative;
}
.custom-multiselect.disabled {
  opacity: 0.6;
}
.multiselect-label {
  color: #8998AB;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: normal;
}
.multiselect-container {
  background: #0D1117;
  border-radius: 12px;
  border: 1px solid #1B222C;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.07);
}
.multiselect-container:focus-within {
  border-color: #4B5F7A;
  box-shadow: 0 0 0 1px rgba(75, 95, 122, 0.3);
}
.multiselect-container.disabled {
  background: #06080B;
  border-color: #0F1419;
  cursor: not-allowed;
}
.multiselect-container.disabled:focus-within {
  border-color: #0F1419;
  box-shadow: none;
}
.multiselect-container.scrollable {
  position: relative;
}
.multiselect-selected {
  min-height: 36px;
  padding: 4px 6px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  overflow-x: hidden;
  gap: 2px;
  transition: all 0.2s ease;
}
/* Size variants based on content */
.multiselect-selected.empty {
  height: 36px;
  max-height: 36px;
  overflow-y: hidden;
  align-items: center;
}
.multiselect-selected.small {
  min-height: 36px;
  max-height: 50px;
  overflow-y: hidden;
  align-items: center;
}
.multiselect-selected.medium {
  min-height: 36px;
  max-height: 64px;
  overflow-y: auto;
  align-items: flex-start;
  padding: 4px 6px 6px 6px;
}
.multiselect-selected.large {
  min-height: 36px;
  max-height: 72px;
  overflow-y: auto;
  align-items: flex-start;
  padding: 4px 6px 6px 6px;
}
.multiselect-pill {
  background: #1D2737;
  color: #FDFDFD;
  border-radius: 3px;
  padding: 2px 6px;
  margin: 1px;
  display: flex;
  align-items: center;
  max-width: 140px;
  overflow: hidden;
  position: relative;
  font-size: 13px;
  flex-shrink: 0;
}
.pill-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
}
.pill-remove {
  background: none;
  border: none;
  color: #98A6B8;
  cursor: pointer;
  font-size: 14px;
  padding: 0 0 0 4px;
  margin-left: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pill-remove:hover {
  color: #FDFDFD;
}
.pill-remove:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.pill-remove:disabled:hover {
  color: #98A6B8;
}
.multiselect-input {
  background: transparent;
  border: none;
  color: #FDFDFD;
  flex-grow: 1;
  flex-shrink: 0;
  min-width: 80px;
  max-width: 100%;
  height: 28px;
  padding: 4px 8px;
  outline: none;
  font-size: 14px;
}
.multiselect-input:disabled {
  color: #4B5F7A;
  cursor: not-allowed;
}
.multiselect-dropdown {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: #0D1117;
  border: 1px solid #1B222C;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.option {
  padding: 8px 10px;
  cursor: pointer;
  color: #8998AB;
  font-size: 13px;
  transition: background 0.2s;
}
.option:hover {
  background: #1D2737;
  color: #FDFDFD;
}
.no-options {
  padding: 8px 10px;
  color: #8998AB;
  font-style: italic;
  font-size: 13px;
}
/* Custom Radio Styles - Evolve-like - prevent flickering */
.custom-radio-group {
  display: flex;
  flex-direction: column;
}
.custom-radio {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  color: #98A6B8;
  position: relative;
  padding-left: 28px;
  min-height: 18px;
}
.custom-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.custom-radio .radio-label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  border: 1px solid #4B5F7A;
  border-radius: 50%;
  background: #0D1117;
}
.custom-radio input:checked + .radio-label::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #4B5F7A;
}
.custom-radio input:checked + .radio-label {
  color: #FDFDFD;
}
.custom-radio .radio-label {
  font-size: 14px;
  line-height: 18px;
  font-weight: normal;
  color: #98A6B8;
}
/* Custom Text Input Styles - Evolve-like - prevent flickering */
.custom-text-input {
  margin-bottom: 10px;
}
.input-label {
  color: #8998AB;
  margin-bottom: 6px;
  display: block;
  font-size: 12px;
  font-weight: normal;
}
.text-input {
  width: 100%;
  padding: 8px 10px;
  background: #0D1117;
  border: 1px solid #1B222C;
  border-radius: 12px;
  color: #FDFDFD;
  outline: none;
  font-size: 14px;
  height: 36px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.07);
}
.text-input:focus {
  border-color: #4B5F7A;
  box-shadow: 0 0 0 1px rgba(75, 95, 122, 0.3);
}
/* Evolve-like section styling - prevent flickering */
.filter-section {
  margin-bottom: 8px;
  border-bottom: 1px solid #1B222C;
  padding-bottom: 6px;
}
.filter-section:last-child {
  border-bottom: none;
}
.evolve-section-body {
  padding: 6px 0;
}
.evolve-form-group {
  margin-top: 10px;
}
/* Override existing sectionHeader */
.filterLayer .filterBody .sectionHeader {
  border-bottom: 1px solid #1B222C;
  padding-bottom: 6px;
  margin-bottom: 2px;
}
.sectionText {
  font-weight: 500;
  color: #FDFDFD;
}
.sectionIcon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
}
.sectionIcon:hover {
  background: #1D2737;
}
/* Evolve-like header styling - prevent flickering */
.evolve-header {
  padding: 12px 14px;
  border-bottom: 1px solid #1B222C;
  display: flex;
  align-items: center;
  background: #0D1117;
}
.evolve-btn {
  padding: 6px;
  cursor: pointer;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.evolve-btn:hover {
  background: #1D2737;
}
.evolve-reset-btn {
  padding: 6px 10px;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  background: transparent;
  transition: background 0.2s;
}
.evolve-reset-btn:hover {
  background: #1D2737;
}
/* Override existing filterText */
.filterLayer .filterHeader .filterText {
  font-weight: 500;
  font-size: 16px;
  flex-grow: 1;
}
.filterResetText {
  font-size: 14px;
}
/* Confirmation Dialog Styles - Matches application modal pattern */
.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5) !important;
  z-index: 10000;
}
.confirm-dialog-overlay .confirm-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 500px;
  width: 90%;
  margin: 0;
  background: none !important;
  animation: fadeInScale 0.2s ease-out;
}
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/map/style/filter.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,+BAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AACF;AACE;EACE,eAAA;EACA,aAAA;AACJ;AAdA;EAiBI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;AAAJ;AA3BA;;;EAgCM,eAAA;EACA,aAAA;AAAN;AAjCA;EAqCM,mBAAA;EACA,iBAAA;AADN;AArCA;EA0CM,YAAA;AAFN;AAxCA;EA8CM,eAAA;EACA,kBAAA;EACA,QAAA;AAHN;AA7CA;EAqDI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,OAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AALJ;AAzDA;EAiEM,aAAA;EACA,8BAAA;EACA,mBAAA;AALN;AA9DA;EAsEQ,gBAAA;EACA,eAAA;AALR;AAlEA;EA2EQ,aAAA;EACA,aAAA;EACA,eAAA;AANR;AAvEA;EAkFM,iBAAA;AARN;AAaA;EAGM,4BAAA;AAbN;AAUA;EAMQ,aAAA;AAbR;AAiBQ;EAEI,cAAA;AAhBZ;AAIA;EAiBU,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,sCAAA;AAlBV;AAFA;EAwBU,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mCAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;AAnBV;AAbA;EAoCU,yBAAA;EACA,qBAAA;AApBV;AAjBA;EA6CM,qCAAA;EACA,2CAAA;EACA,0BAAA;AAzBN;AAtBA;EAkDQ,gBAAA;EACA,eAAA;EACA,iBAAA;AAzBR;AA3BA;EA6DQ,uBAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;AA/BR;AAuBQ;EACE,mBAAA;EACA,iBAAA;AArBV;AArCA;EAuEM,mCAAA;EACA,wBAAA;EACA,+BAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EACA,WAAA;AA/BN;AAoCA;EACE,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AAlCF;AAqCA;EACE,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yDAAA;EACA,UAAA;EACA,2BAAA;AAnCF;AACA,kCAAkC;AAsClC;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BAAA;EACA,WAAA;EACA,wCAAA;AApCF;AAuCA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AArCF;AAwCA;EACE,yBAAA;AAtCF;AAyCA;EACE,kBAAA;AAvCF;AACA,iDAAiD;AA0CjD;;EAEE,UAAA;AAxCF;AA2CA;;EAEE,uBAAA;AAzCF;AA4CA;;EAEE,mBAAA;EACA,kBAAA;AA1CF;AA6CA;;EAEE,mBAAA;AA3CF;AACA,kEAAkE;AA8ClE;EACE,mBAAA;EACA,kBAAA;AA5CF;AA+CA;EACE,YAAA;AA7CF;AAgDA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AA9CF;AAiDA;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,+CAAA;AA/CF;AAkDA;EACE,qBAAA;EACA,4CAAA;AAhDF;AAmDA;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;AAjDF;AAoDA;EACE,qBAAA;EACA,gBAAA;AAlDF;AAqDA;EACE,kBAAA;AAnDF;AAsDA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;AApDF;AACA,mCAAmC;AAuDnC;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AArDF;AAwDA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAtDF;AAyDA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;AAvDF;AA0DA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;AAxDF;AA2DA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAzDF;AA4DA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AA1DF;AA6DA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3DF;AA8DA;EACE,cAAA;AA5DF;AA+DA;EACE,mBAAA;EACA,YAAA;AA7DF;AAgEA;EACE,cAAA;AA9DF;AAiEA;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AA/DF;AAkEA;EACE,cAAA;EACA,mBAAA;AAhEF;AAmEA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,wCAAA;AAjEF;AAoEA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;AAlEF;AAqEA;EACE,mBAAA;EACA,cAAA;AAnEF;AAsEA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AApEF;AACA,2DAA2D;AAuE3D;EACE,aAAA;EACA,sBAAA;AArEF;AAwEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAtEF;AAyEA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AAvEF;AA0EA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAxEF;AA2EA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAzEF;AA4EA;EACE,cAAA;AA1EF;AA6EA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AA3EF;AACA,gEAAgE;AA8EhE;EACE,mBAAA;AA5EF;AA+EA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AA7EF;AAgFA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,+CAAA;AA9EF;AAiFA;EACE,qBAAA;EACA,4CAAA;AA/EF;AACA,qDAAqD;AAkFrD;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;AAhFF;AAmFA;EACE,mBAAA;AAjFF;AAoFA;EACE,cAAA;AAlFF;AAqFA;EACE,gBAAA;AAnFF;AACA,oCAAoC;AAsFpC;EACE,gCAAA;EACA,mBAAA;EACA,kBAAA;AApFF;AAuFA;EACE,gBAAA;EACA,cAAA;AArFF;AAwFA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAtFF;AAyFA;EACE,mBAAA;AAvFF;AACA,oDAAoD;AA0FpD;EACE,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAxFF;AA2FA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzFF;AA4FA;EACE,mBAAA;AA1FF;AA6FA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AA3FF;AA8FA;EACE,mBAAA;AA5FF;AACA,iCAAiC;AA+FjC;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AA7FF;AAgGA;EACE,eAAA;AA9FF;AACA,mEAAmE;AAiGnE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,cAAA;AA/FF;AAwFA;EAUI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,oCAAA;AA/FJ;AAmGA;EACE;IACE,UAAA;IACA,2CAAA;EAjGF;EAoGA;IACE,UAAA;IACA,yCAAA;EAlGF;AACF","sourcesContent":[".filterLayer {\n  width: 292px;\n  height: 60vh;\n  border-right: 1px solid #2A3A4F;\n  border-top-right-radius: 12px;\n  background-color: #121B26;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  z-index: 1;\n\n  &.expandView {\n    position: fixed;\n    height: 100vh;\n  }\n\n  .filterHeader {\n    width: unset;\n    height: 40px;\n    background-color: #0E2343;\n    border-top-right-radius: 12px;\n    color: #FDFDFD;\n    display: flex;\n    align-items: center;\n    padding: 0 12px;\n    font-weight: 500;\n    font-size: 14px;\n    gap: 8px;\n\n    .filterBack,\n    .filterReset,\n    .filterParent {\n      cursor: pointer;\n      display: flex;\n    }\n\n    .filterReset {\n      align-items: center;\n      margin-right: 6px;\n    }\n\n    .filterText {\n      flex-grow: 1;\n    }\n\n    .filterResetText {\n      font-size: 12px;\n      position: relative;\n      top: 1px;\n    }\n  }\n\n  .filterBody {\n    height: calc(100% - 56px);\n    margin-right: 5px;\n    margin-top: 16px;\n    flex: 1;\n    padding: 16px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    overflow-y: auto;\n    padding-top: 0px;\n\n    .sectionHeader {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .sectionText {\n        font-weight: 600;\n        font-size: 14px;\n      }\n\n      .sectionIcon {\n        display: flex;\n        fill: #98A6B8;\n        cursor: pointer;\n      }\n    }\n\n    .padding-top-14 {\n      padding-top: 14px;\n    }\n  }\n}\n\n.sectionBody {\n  .radioParent {\n    ev-radio-group {\n      display: contents !important;\n\n      label {\n        display: none;\n      }\n\n      ev-radio {\n        &[checked] {\n          label {\n            color: #FDFDFD;\n          }\n        }\n\n        label {\n          color: #8998AB;\n          display: inline-block;\n          margin-bottom: 0px;\n          font-weight: var(--font-weight-medium);\n        }\n\n        .form-control {\n          display: flex;\n          width: 1.0625rem;\n          height: 1.0625rem;\n          border: 3px solid transparent;\n          border-radius: 50%;\n          box-shadow: 0 0 0 0.0625rem #5D718C;\n          margin: 0;\n          outline: none;\n          background-color: #0D1117;\n        }\n\n        input[type=\"radio\"]:checked {\n          background-color: #8BB6F7;\n          border-color: #0D1117;\n        }\n      }\n    }\n  }\n\n  .textfield {\n    ev-text-input {\n      --color-input-default-border: #384D69;\n      --color-input-default-border-hover: #384D69;\n      --color-highlight: #386DFF;\n\n      label {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 18px;\n      }\n\n      .form-control {\n        &:focus {\n          border-color: unset;\n          box-shadow: unset;\n        }\n\n        background-color: unset;\n        border: unset;\n        cursor: unset;\n        color: #FDFDFD;\n      }\n    }\n  }\n\n  .multiselect {\n    ev-combobox {\n      --color-neutral-background: #0D1117;\n      --color-red-600: #1C2633;\n      --color-neutral-border: #8998AB;\n      --color-neutral-surface-1: #1C2633;\n      --color-neutral-surface-2: #1C2633;\n      --color-neutral-surface-3: #1C2633;\n      --color-primary-surface-2: #1C2633;\n      --color-neutral-surface-4: #384D69;\n      --color-neutral-text-medium: #8998AB;\n      width: 100%;\n    }\n  }\n}\n\n.floating-tooltip {\n  position: fixed;\n  transform: translateX(-50%);\n  background: #2563eb;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  line-height: 16px;\n  white-space: nowrap;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n.floating-tooltip .tooltip-arrow {\n  position: absolute;\n  top: 24px;\n  border-width: 11px;\n  border-style: solid;\n  border-color: #2563eb transparent transparent transparent;\n  opacity: 1;\n  transform: translateX(-50%);\n}\n\n/* Text input suggestions styles */\n.text-suggestions {\n  position: absolute;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  background: white;\n  border: 1px solid #ccc;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  z-index: 10;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.suggestion-item {\n  padding: 8px 12px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #333;\n}\n\n.suggestion-item:hover {\n  background-color: #f0f0f0;\n}\n\n.custom-text-input {\n  position: relative;\n}\n\n/* Custom scrollbar styles - prevent flickering */\n.scrollContent::-webkit-scrollbar,\n.multiselect-selected::-webkit-scrollbar {\n  width: 3px;\n}\n\n.scrollContent::-webkit-scrollbar-track,\n.multiselect-selected::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scrollContent::-webkit-scrollbar-thumb,\n.multiselect-selected::-webkit-scrollbar-thumb {\n  background: #4B5F7A;\n  border-radius: 4px;\n}\n\n.scrollContent::-webkit-scrollbar-thumb:hover,\n.multiselect-selected::-webkit-scrollbar-thumb:hover {\n  background: #3a4b60;\n}\n\n/* Custom Multi-Select Styles - Evolve-like - prevent flickering */\n.custom-multiselect {\n  margin-bottom: 10px;\n  position: relative;\n}\n\n.custom-multiselect.disabled {\n  opacity: 0.6;\n}\n\n.multiselect-label {\n  color: #8998AB;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.multiselect-container {\n  background: #0D1117;\n  border-radius: 12px;\n  border: 1px solid #1B222C;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.07);\n}\n\n.multiselect-container:focus-within {\n  border-color: #4B5F7A;\n  box-shadow: 0 0 0 1px rgba(75, 95, 122, 0.3);\n}\n\n.multiselect-container.disabled {\n  background: #06080B;\n  border-color: #0F1419;\n  cursor: not-allowed;\n}\n\n.multiselect-container.disabled:focus-within {\n  border-color: #0F1419;\n  box-shadow: none;\n}\n\n.multiselect-container.scrollable {\n  position: relative;\n}\n\n.multiselect-selected {\n  min-height: 36px;\n  padding: 4px 6px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  align-content: flex-start;\n  overflow-x: hidden;\n  gap: 2px;\n  transition: all 0.2s ease;\n}\n\n/* Size variants based on content */\n.multiselect-selected.empty {\n  height: 36px;\n  max-height: 36px;\n  overflow-y: hidden;\n  align-items: center;\n}\n\n.multiselect-selected.small {\n  min-height: 36px;\n  max-height: 50px;\n  overflow-y: hidden;\n  align-items: center;\n}\n\n.multiselect-selected.medium {\n  min-height: 36px;\n  max-height: 64px;\n  overflow-y: auto;\n  align-items: flex-start;\n  padding: 4px 6px 6px 6px;\n}\n\n.multiselect-selected.large {\n  min-height: 36px;\n  max-height: 72px;\n  overflow-y: auto;\n  align-items: flex-start;\n  padding: 4px 6px 6px 6px;\n}\n\n.multiselect-pill {\n  background: #1D2737;\n  color: #FDFDFD;\n  border-radius: 3px;\n  padding: 2px 6px;\n  margin: 1px;\n  display: flex;\n  align-items: center;\n  max-width: 140px;\n  overflow: hidden;\n  position: relative;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.pill-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 13px;\n}\n\n.pill-remove {\n  background: none;\n  border: none;\n  color: #98A6B8;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0 0 0 4px;\n  margin-left: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pill-remove:hover {\n  color: #FDFDFD;\n}\n\n.pill-remove:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.pill-remove:disabled:hover {\n  color: #98A6B8;\n}\n\n.multiselect-input {\n  background: transparent;\n  border: none;\n  color: #FDFDFD;\n  flex-grow: 1;\n  flex-shrink: 0;\n  min-width: 80px;\n  max-width: 100%;\n  height: 28px;\n  padding: 4px 8px;\n  outline: none;\n  font-size: 14px;\n}\n\n.multiselect-input:disabled {\n  color: #4B5F7A;\n  cursor: not-allowed;\n}\n\n.multiselect-dropdown {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  background: #0D1117;\n  border: 1px solid #1B222C;\n  border-radius: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.option {\n  padding: 8px 10px;\n  cursor: pointer;\n  color: #8998AB;\n  font-size: 13px;\n  transition: background 0.2s;\n}\n\n.option:hover {\n  background: #1D2737;\n  color: #FDFDFD;\n}\n\n.no-options {\n  padding: 8px 10px;\n  color: #8998AB;\n  font-style: italic;\n  font-size: 13px;\n}\n\n/* Custom Radio Styles - Evolve-like - prevent flickering */\n.custom-radio-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-radio {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  cursor: pointer;\n  color: #98A6B8;\n  position: relative;\n  padding-left: 28px;\n  min-height: 18px;\n}\n\n.custom-radio input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n.custom-radio .radio-label::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  border: 1px solid #4B5F7A;\n  border-radius: 50%;\n  background: #0D1117;\n}\n\n.custom-radio input:checked+.radio-label::after {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #4B5F7A;\n}\n\n.custom-radio input:checked+.radio-label {\n  color: #FDFDFD;\n}\n\n.custom-radio .radio-label {\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: normal;\n  color: #98A6B8;\n}\n\n/* Custom Text Input Styles - Evolve-like - prevent flickering */\n.custom-text-input {\n  margin-bottom: 10px;\n}\n\n.input-label {\n  color: #8998AB;\n  margin-bottom: 6px;\n  display: block;\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.text-input {\n  width: 100%;\n  padding: 8px 10px;\n  background: #0D1117;\n  border: 1px solid #1B222C;\n  border-radius: 12px;\n  color: #FDFDFD;\n  outline: none;\n  font-size: 14px;\n  height: 36px;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.07);\n}\n\n.text-input:focus {\n  border-color: #4B5F7A;\n  box-shadow: 0 0 0 1px rgba(75, 95, 122, 0.3);\n}\n\n/* Evolve-like section styling - prevent flickering */\n.filter-section {\n  margin-bottom: 8px;\n  border-bottom: 1px solid #1B222C;\n  padding-bottom: 6px;\n}\n\n.filter-section:last-child {\n  border-bottom: none;\n}\n\n.evolve-section-body {\n  padding: 6px 0;\n}\n\n.evolve-form-group {\n  margin-top: 10px;\n}\n\n/* Override existing sectionHeader */\n.filterLayer .filterBody .sectionHeader {\n  border-bottom: 1px solid #1B222C;\n  padding-bottom: 6px;\n  margin-bottom: 2px;\n}\n\n.sectionText {\n  font-weight: 500;\n  color: #FDFDFD;\n}\n\n.sectionIcon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n}\n\n.sectionIcon:hover {\n  background: #1D2737;\n}\n\n/* Evolve-like header styling - prevent flickering */\n.evolve-header {\n  padding: 12px 14px;\n  border-bottom: 1px solid #1B222C;\n  display: flex;\n  align-items: center;\n  background: #0D1117;\n}\n\n.evolve-btn {\n  padding: 6px;\n  cursor: pointer;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.evolve-btn:hover {\n  background: #1D2737;\n}\n\n.evolve-reset-btn {\n  padding: 6px 10px;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background: transparent;\n  transition: background 0.2s;\n}\n\n.evolve-reset-btn:hover {\n  background: #1D2737;\n}\n\n/* Override existing filterText */\n.filterLayer .filterHeader .filterText {\n  font-weight: 500;\n  font-size: 16px;\n  flex-grow: 1;\n}\n\n.filterResetText {\n  font-size: 14px;\n}\n\n/* Confirmation Dialog Styles - Matches application modal pattern */\n.confirm-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5) !important;\n  z-index: 10000;\n\n  .confirm-dialog {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 500px;\n    width: 90%;\n    margin: 0;\n    background: none !important;\n    animation: fadeInScale 0.2s ease-out;\n  }\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
